import React, { useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import '../../assets/css/Custom.css'
import { productdetail3 } from "../../constant";
import { useSelector } from "react-redux";
import { ramdomImage } from "../../constant/ConstantFunction";

function DonarListModal(props) {
  const { setIsOpenDonarModal, isOpenDonarModal, campaignDetails } = props;
  const ImageUrlRedux = useSelector((state) => state.AuthReducer.urlData);
  const Navigate = useNavigate();

  return (
    <>
      <Modal
        isOpen={isOpenDonarModal}
        toggle={() => {
          setIsOpenDonarModal(false);
        }}
        className="custom-modal modal-width orderView-Modal"
      >
       
     
        <div id="donors" >
          <div
          >
            <div
            //   className="modal-content"
            >
              <div className="modal-header">
                <h5 className="modal-title donation-title">Donors List</h5>
                {/* <!-- <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> --> */}
              </div>
              <div className="modal-body">
                <div className="donor-list">
                  {campaignDetails?.donors?.map((item, index) => {
                    return (
                      <div className="" key={index}>
                        <div className="row my-3">
                          <div className="col-md-2 px-0">
                            <div className="img-box">
                              <figure>
                                {item?.user?.image == null ? (
                                  <img
                                    src={`${ramdomImage(
                                      `${item?.user?.f_name}{" "}${item?.user?.l_name}`
                                    )}`}
                                    className="image-fluid image-width"
                                    style={{ borderRadius: "50%", width: "100%" }}
                                    alt=""
                                  />
                                ) : (
                                  <img
                                    src={`${ImageUrlRedux?.customer_image_url}/${item?.user?.image}`}
                                    alt="all-Images"
                                    className="img-fuild"
                                  />
                                )}
                                {/* <img src={image} className="img-fluid" /> */}
                              </figure>
                            </div>
                          </div>
                          <div className="col-md-4 align-center px-0">
                            <div className="content ml-3">
                              <div className="header">
                                <div className="name name_donar_moadl">
                                  <h4>
                                    {item?.user?.f_name}
                                    {" "}
                                    {item?.user?.l_name}
                                  </h4>
                                </div>
                              </div>
                              {/* <p>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                                sed do eiusmod tempor incididunt
                              </p> */}
                            </div>
                          </div>
                          <div className="col-md-6 align-center text-right px-0">
                            <div className="content ml-3">
                              <div className="header">
                                <div className="amount donar_modal_amount_tag">
                                  <p>
                                    <span className="property">Donated Amount: </span>
                                    <span className="value">
                                      $ {item?.amount}
                                    </span>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default DonarListModal;
